jQuery(document).ready(function($){
	$('.modal').append('<div class="modal-bg"></div>')
	$('.modal > form, .modal > .message').append('<span class="modal-close">&times;</span>')

	$('.modal-bg').click(function(){
		$(this).parent().removeClass('show')
	})

	$('.modal-close').click(function(){
		$(this).parent().parent().removeClass('show')
	})

	$(document).keyup((e) => {
		if (e.keyCode == 27) $('.modal').removeClass('show')
	})

	$('.get-form').click(function(e){
		e.preventDefault()

		const id = $(this).data('id')
		const form = $('#'+id)

		if (!form) return false

		if (id === 'form-order' && $(this).data('doctor')) {
			const docId = $(this).data('doctor')
			$('#form-order select[name=doctor] option').each(function(){
				return ($(this).data('id') === docId) 
				? $(this).prop('selected',true)
				: $(this).prop('selected',false)
			})
		}

		$('.modal').removeClass('show')
		
		form.addClass('show')
	})

	$('.modal > form').find('input[type=text], textarea').blur(function() {
		return ($(this).val() === '') ? $(this).parent().addClass('error') : $(this).parent().removeClass('error')
	})

	$('.modal > form').submit((e) => {
		e.preventDefault()

		const $els = $(e.currentTarget).find('input[type=text],textarea')
		let cntErrors = 0

		$els.each(function(){
			if ($(this).val() === '') {
				$(this).parent().addClass('error')
				cntErrors++
			}
		})

		if (!$('#private-politic').prop('checked')){ 
			alert(`Требуется согласие на обработку персональных данных`)
			return false
		}

		if (!cntErrors) {
			$('.loader').addClass('show')
			const formData = new FormData(e.currentTarget)

			$.ajax({
				url: '/ajax.php',
				data: formData,
				processData: false,
				cache: false,
				contentType: false,
				dataType : 'json',
				type: 'POST'
			}).error((e) => {
				$('.loader').removeClass('show')
				$('.modal').removeClass('show')
				showTempModal('#modal-error')
			}).done((data) => {
				$('.loader').removeClass('show')
				$('.modal').removeClass('show')
				if (data.success) showTempModal('#modal-success')
					else showTempModal('#modal-error')
			})
		}
	})
})

function showTempModal(modalId) {
	$(modalId).addClass('show')

	setTimeout(() => {
		$(modalId).removeClass('show')
	},5000)
}